import {
  ErrorNotification,
  GraviButton,
  Horizontal,
  NotificationMessage,
  Texto,
  Vertical,
} from '@gravitate-js/excalibrr'
import React, { useState } from 'react'
import { Button, Form, Input, Popover, Select } from 'antd'
import { useValuation } from '@api/useValuation'
import TextArea from 'antd/es/input/TextArea'
import { CheckCircleFilled, DeleteFilled, EditOutlined, PlusCircleOutlined } from '@ant-design/icons'
import moment from 'moment'
const { Option } = Select
export function CreateManualLayerForm({ date, inventory_costing_identifier, setIsAddingLayer, reasonCodes }) {
  const [form] = Form.useForm()
  const { addManualLayerMutation } = useValuation()
  const { mutateAsync: addManualLayer } = addManualLayerMutation()
  const onFinish = async (values) => {
    const request = {
      ...values,
      type: 'adjustment',
      date: moment(date).hours(0).minutes(0).format('YYYY-MM-DDTHH:mm:ss'),
      inventory_costing_identifier,
    }
    try {
      await addManualLayer(request).then(() => {
        NotificationMessage('New layer added', 'New layer added successfully', false)
        form.resetFields()
        setIsAddingLayer(false)
      })
    } catch (e) {
      NotificationMessage('Problem saving new layer', `ERROR: ${e}`, true)
    }
  }
  const cancelAddLayer = () => {
    form.resetFields()
    setIsAddingLayer(false)
  }

  return (
    <Form
      form={form}
      name={'manualLayerCreationForm'}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={ErrorNotification}
      autoComplete='off'
    >
      <Horizontal
        className='p-2 border-left border-right bg-1'
        style={{
          width: '100%',
          maxHeight: '30px',
        }}
        alignItems={'center'}
      >
        <Vertical alignItems={'flex-start'} className='ml-2 mr-4' flex={1}></Vertical>
        <Vertical
          style={{ minWidth: '125px' }}
          className='mr-2 ml-2'
          flex={1}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          <Texto appearance={'medium'}>Reason</Texto>
        </Vertical>
        <Vertical className='mr-2 ml-1' flex={1} alignItems={'flex-start'} justifyContent={'center'}>
          <Texto appearance={'medium'}> Volume</Texto>
        </Vertical>
        <Vertical className='mr-2 ml-1' flex={1} alignItems={'flex-start'} justifyContent={'center'}>
          <Texto appearance={'medium'}> Value</Texto>
        </Vertical>
        <Vertical flex={1.5} className='ml-2 mr-2' justifyContent={'center'} />
      </Horizontal>

      <Horizontal
        className='border-left border-right border-bottom bg-1'
        style={{ maxHeight: '40px', width: '100%' }}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Vertical flex={1} className='ml-3 mr-2'>
          <NoteButton form={form} />
        </Vertical>

        <Vertical style={{ minWidth: '125px' }} flex={1} className='ml-2 mr-2 mt-4' alignItems={'flex-start'}>
          <Form.Item name='reason_code' rules={[{ required: true, message: 'Reason is required.' }]}>
            <Select placeholder={'Reason'} style={{ width: '125px' }}>
              {reasonCodes?.adjustment_reason_codes?.map((reason) => (
                <Option value={reason} key={reason}>
                  {reason}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Vertical>
        <Vertical className='mr-2 mt-4' flex={1} alignItems={'flex-start'} justifyContent={'center'}>
          <Form.Item name='volume' rules={[{ required: true, message: 'Volume is required.' }]}>
            <Input placeholder={'Enter Volume'} type={'number'} />
          </Form.Item>
        </Vertical>
        <Vertical className='mr-2 mt-4' flex={1} alignItems={'flex-start'} justifyContent={'center'}>
          <Form.Item name='value' rules={[{ required: true, message: 'Value is required.' }]}>
            <Input placeholder={'Enter Value'} type={'number'} />
          </Form.Item>
        </Vertical>
        <Vertical flex={1.5} className='ml-2 mr-2' justifyContent={'center'}>
          <Horizontal justifyContent={'flex-end'} alignItems={'center'}>
            <GraviButton className='mr-2' buttonText='Cancel' onClick={cancelAddLayer} />
            <GraviButton className='mr-2' theme2 buttonText='Save' htmlType='submit' />
          </Horizontal>
        </Vertical>
      </Horizontal>
    </Form>
  )
}

export function NoteButton({ form }) {
  const [isAddingNote, setIsAddingNote] = useState(false)
  const [noteAdded, setNoteAdded] = useState(false)

  return (
    <Popover
      placement='left'
      content={
        <div className='ml-3 mr-3 vertical-flex'>
          <Form.Item name='notes'>
            <TextArea style={{ width: '300px' }} />
          </Form.Item>
          <div className='flex'>
            <GraviButton
              buttonText='Cancel'
              appearance='outline'
              onClick={() => {
                if (!noteAdded) {
                  form.setFieldsValue({ notes: '' })
                  setNoteAdded(false)
                } else {
                  setNoteAdded(true)
                }
                setIsAddingNote(false)
              }}
              size='small'
            />
            <GraviButton
              success
              appearance='outline'
              buttonText='Attach Note'
              htmlType='submit'
              className='ml-2'
              onClick={() => {
                setNoteAdded(true)
                setIsAddingNote(false)
              }}
              size='small'
            />
          </div>
        </div>
      }
      title='Add Note'
      trigger='click'
      visible={isAddingNote}
    >
      {noteAdded ? (
        <Horizontal justifyContent={'space-between'} alignItems={'center'}>
          <Texto>
            <CheckCircleFilled /> Note Added
          </Texto>
          <Horizontal alignItems={'center'}>
            <GraviButton
              size='small'
              appearance='outline'
              className='add-special-pay-note-btn p-0 mr-1 ml-1'
              onClick={() => {
                setIsAddingNote(true)
              }}
              icon={<EditOutlined />}
              title='Edit Note'
            />
            <GraviButton
              size='small'
              error
              icon={<DeleteFilled />}
              onClick={() => {
                setIsAddingNote(false)
                setNoteAdded(false)
                form.setFieldsValue({ notes: undefined })
              }}
              title='Remove Note'
            />
          </Horizontal>
        </Horizontal>
      ) : (
        <Button type='text' onClick={() => setIsAddingNote(true)} size='small' icon={<PlusCircleOutlined />}>
          Add Note
        </Button>
      )}
    </Popover>
  )
}
